/**
 * @module app.ext.mcg-informed
 */
import { autoinject, bindingMode } from "aurelia-framework";
import { bindable } from 'aurelia-typed-observable-plugin';
import { AssessmentContext } from 'app/core/lib/assessment-context';
import { EssDialogCustomElement } from 'app/shared/elements/ess-dialog';
import * as Core from 'app/core/models/essette-api';

@autoinject
export class QuestionView {
    ////****************** Fields and Properties ************************************////
    @bindable.objectNull({ defaultBindingMode: bindingMode.toView })
    protected question: Core.AssessmentQuestion | null = null;

    @bindable.numberNull({ defaultBindingMode: bindingMode.toView })
    protected number: number | null = null;

    @bindable.objectNull({ defaultBindingMode: bindingMode.toView })
    protected context: AssessmentContext | null = null;

    @bindable.objectNull({ defaultBindingMode: bindingMode.toView })
    public qualityMeasuresModal: EssDialogCustomElement | null = null;

    @bindable.stringNull()
    protected labelId: string | undefined;

    ////****************** Lifecycle events (in order of execution) *****************////
    constructor() { }

    ////****************** Events ***************************************************////
}
